module.exports = __webpack_public_path__ + "Logo_TSI_512PX.jpg";